var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjectAccessSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.479,
    height: 50.801,
    viewBox: "0 0 41.479 50.801",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1067",
    "data-name": "Group 1067",
    transform: "translate(-6595.848 -6885.77)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_818",
    "data-name": "Path 818",
    d: "M6623.973,6910.414a36.314,36.314,0,0,0-8.325-1.138c-6.645,0-19.8,3.295-19.8,10.031v12.464h21.946V6921.7c0-.488.165-.653.653-.653h1.284v-1.788a6.83,6.83,0,0,1,.515-2.7,6.011,6.011,0,0,1,.256-.565,6.637,6.637,0,0,1,4.149-3.375c.453-.13.929-.183,1.394-.271l1.379-.311C6627.795,6912.1,6626.315,6910.859,6623.973,6910.414Z",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_819",
    "data-name": "Path 819",
    d: "M6615.649,6902.969a8.6,8.6,0,1,0-8.484-8.754v.154A8.568,8.568,0,0,0,6615.649,6902.969Z",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_820",
    "data-name": "Path 820",
    d: "M6615.65,6902.969h0Z",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_821",
    "data-name": "Path 821",
    d: "M6636.669,6922.059H6635.4c0-.088-.011-.168-.011-.247,0-.612,0-1.224-.009-1.835a6.755,6.755,0,0,0-5.192-6.431c-.367-.087-.742-.129-1.112-.191h-.907c-.465.088-.941.141-1.394.271a6.637,6.637,0,0,0-4.149,3.375,5.709,5.709,0,0,0-.256.565,6.815,6.815,0,0,0-.515,2.705v1.788h-1.285c-.487,0-.652.165-.652.653V6934.5a1.954,1.954,0,0,0,.954,1.787,2.216,2.216,0,0,0,1.121.282h13.259a1.956,1.956,0,0,0,2.075-2.069v-11.786C6637.323,6922.224,6637.158,6922.06,6636.669,6922.059Zm-6.612,9.991a.516.516,0,0,1-.361.634.51.51,0,0,1-.194.016c-.3.008-.6,0-.9,0s-.575.007-.861,0a.516.516,0,0,1-.572-.454.524.524,0,0,1,.015-.193c.092-.825.187-1.65.271-2.476a.333.333,0,0,0-.089-.246,1.927,1.927,0,1,1,2.5.013.269.269,0,0,0-.077.208C6629.869,6930.385,6629.964,6931.218,6630.057,6932.05Zm2.419-10h-7.684c-.014-.018-.032-.028-.032-.04a11.259,11.259,0,0,1,.13-2.884,3.68,3.68,0,0,1,2.963-2.779l.036-.01a3.7,3.7,0,0,1,3.793,1.437,3.575,3.575,0,0,1,.794,2.219C6632.487,6920.676,6632.476,6921.354,6632.476,6922.054Z",
    fill: "#707070"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectAccessSetting);
export default __webpack_public_path__ + "static/media/project_access_setting.0fb5991efb3cb53ebb0b263acc9363ea.svg";
export { ForwardRef as ReactComponent };